'use client';

import { atom } from 'jotai';
import {
  CalculatorMessages,
  defaultCalculatorMessages,
} from '../Components/FinancingCalculator/Calculator.messages';

export const finCalcMessagesAtom = atom<CalculatorMessages>(defaultCalculatorMessages);
